import React from "react";

export const serverConnectionState = (server, now = Date.now()) => {
    const checked = Date.parse(server.last_checked_at || "");
    if (server.is_enabled === false || !Number.isFinite(checked) || now - checked > 60000) return "UNKNOWN";
    return ["ONLINE", "OFFLINE", "UNKNOWN"].includes(server.connection_status) ? server.connection_status : "UNKNOWN";
};

const displayTime = (value) => {
    const time = new Date(value);
    return Number.isNaN(time.getTime()) ? "—" : time.toLocaleString();
};

export function ServerConnectionStatus({ server, now }) {
    const status = serverConnectionState(server, now);
    return <div className="server-page__health">
        <span className={`server-page__connection is-${status.toLowerCase()}`} aria-label={`Connection status: ${status.toLowerCase()}`}>
            {status === "ONLINE" ? "Online" : status === "OFFLINE" ? "Offline" : "Unknown"}
        </span>
        <small>{server.last_checked_at ? `Checked: ${displayTime(server.last_checked_at)}` : "Not checked yet"}</small>
    </div>;
}

export function ServerLastError({ server, now }) {
    if (serverConnectionState(server, now) === "ONLINE") return <span className="server-page__no-error">No current error</span>;
    if (!server.last_error_code && !server.last_error_message) return <span className="server-page__no-error">No collector result yet</span>;
    return <div className="server-page__last-error">
        {server.last_error_code && <code>{server.last_error_code}</code>}
        {server.last_error_message && <span>{server.last_error_message}</span>}
        {server.last_error_at && <small>{displayTime(server.last_error_at)}</small>}
    </div>;
}
